import React = require('react');
import { ButtonType,ButtonWidget } from '@tableau/widgets';

import { Messages } from '~src/codegen/Localize';
import { FileDragAndDrop, preventDefaultDrag } from '~src/uploadContent/components/FileDragAndDrop';
import { FileInputProps } from '~src/userManagement/components/FileInput';
import { BulkImportUserDialogStyle } from '~src/userManagement/components/styles/BulkImportUserDialogStyle';

import { samlProviderdragAndDropContainer } from '../styles/SAMLAuthenticationProviderStyle';

// This class is copied from FileInput.  Needed styling specific to authentication page
export class AuthenticationFileInput extends React.PureComponent<FileInputProps>{
    private fileInput: React.RefObject<HTMLInputElement>;
    constructor(props: FileInputProps) {
        super(props);
        this.fileInput = React.createRef();
    }
    public render() {

        return (
            <div>
                <div>
                    <input
                        type="file"
                        data-tb-test-id={this.props.fileUploadId ? this.props.fileUploadId : ' '}
                        ref={this.fileInput}
                        style={{ display: 'none'}}
                        onChange={this.handleFileInputChange}
                        name={this.props.name ? this.props.name : ''}
                    />
                    <FileDragAndDrop
                        handleDrop={(event: React.ChangeEvent<HTMLInputElement>) => this.handleFileInputChange(event)}
                        containerClassName={samlProviderdragAndDropContainer}
                        defaultStateClassName={BulkImportUserDialogStyle.defaultOutline}
                        activeStateClassName={BulkImportUserDialogStyle.activeOutline}
                        onDragClassName={BulkImportUserDialogStyle.focusOutline}
                        testId="bulk-import-user-dialog-file"
                    >
                        <div className={BulkImportUserDialogStyle.dragAndDropChildren} onDragLeave={preventDefaultDrag}>
                            {this.props.fileName &&
                                <b className={BulkImportUserDialogStyle.fileName}>{this.props.fileName}</b>
                            }
                            {!this.props.fileName &&
                                <>
                                    <p className={BulkImportUserDialogStyle.dragAndDropText}>{Messages.contentUpload_dragAndDrop()}</p>
                                    <p className={BulkImportUserDialogStyle.dragAndDropOrText}>{Messages.contentUpload_dragAndDropOr()}</p>{}
                                </>
                            }
                            <ButtonWidget
                                buttonType={ButtonType.Outline}
                                type="button"
                                testId="import-user-browse"
                                children={Messages.contentUpload_chooseAFile()}
                                handleClick={this.triggerFileInput}
                                name={this.props.name ? this.props.name : ''}
                                disabled={this.props.disabled ? this.props.disabled : false}
                            />
                        </div>
                    </FileDragAndDrop>
                </div>
            </div>
        );
    }

    private handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files.length > 0) {
            const fileInput: File = event.target.files[0];
            const name = fileInput.name.split('\\').pop();
            this.props.handleFileInput(fileInput);
        } else{
            this.props.handleFileInput(null);
        }
    };

    private triggerFileInput = () => {
        this.fileInput.current.click();
    };

}